export default function Benefits() {
  return (
    <section className="py-24 bg-gradient-to-b from-amber-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-gray-900 mb-6">Benefits for Authors</h2>
          <div className="w-24 h-1 bg-amber-500 mx-auto mb-8"></div>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto">
            What you gain from an APEX book club campaign
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300">
            <div className="w-16 h-16 bg-gradient-to-br from-amber-400 to-amber-600 rounded-xl flex items-center justify-center mb-6">
              <i className="ri-eye-line text-3xl text-white"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4">Increased Visibility</h3>
            <p className="text-gray-700 leading-relaxed">
              Your book reaches hundreds of engaged readers across our network of 300+ active book clubs, both online and in-person.
            </p>
          </div>
          
          <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300">
            <div className="w-16 h-16 bg-gradient-to-br from-amber-400 to-amber-600 rounded-xl flex items-center justify-center mb-6">
              <i className="ri-heart-line text-3xl text-white"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4">Genuine Engagement</h3>
            <p className="text-gray-700 leading-relaxed">
              Connect with readers who are genuinely interested in your story and eager to discuss it with their communities.
            </p>
          </div>
          
          <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300">
            <div className="w-16 h-16 bg-gradient-to-br from-amber-400 to-amber-600 rounded-xl flex items-center justify-center mb-6">
              <i className="ri-speed-line text-3xl text-white"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4">Fast Reviews</h3>
            <p className="text-gray-700 leading-relaxed">
              Book club members are active readers who leave thoughtful reviews quickly, helping build your book's credibility.
            </p>
          </div>
          
          <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300">
            <div className="w-16 h-16 bg-gradient-to-br from-amber-400 to-amber-600 rounded-xl flex items-center justify-center mb-6">
              <i className="ri-target-line text-3xl text-white"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4">Perfect Positioning</h3>
            <p className="text-gray-700 leading-relaxed">
              We know exactly how to present your book to make readers genuinely interested and excited to dive into your story.
            </p>
          </div>
          
          <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300">
            <div className="w-16 h-16 bg-gradient-to-br from-amber-400 to-amber-600 rounded-xl flex items-center justify-center mb-6">
              <i className="ri-discuss-line text-3xl text-white"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4">Meaningful Discussions</h3>
            <p className="text-gray-700 leading-relaxed">
              Your book becomes the center of thoughtful conversations in communities that value literature and storytelling.
            </p>
          </div>
          
          <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300">
            <div className="w-16 h-16 bg-gradient-to-br from-amber-400 to-amber-600 rounded-xl flex items-center justify-center mb-6">
              <i className="ri-trophy-line text-3xl text-white"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4">Long-term Impact</h3>
            <p className="text-gray-700 leading-relaxed">
              Book club recommendations create lasting word-of-mouth promotion that extends far beyond the initial campaign.
            </p>
          </div>
        </div>
        
        <div className="mt-16 text-center">
          <div className="bg-white rounded-2xl p-10 shadow-xl max-w-4xl mx-auto border-t-4 border-amber-500">
            <i className="ri-information-line text-5xl text-amber-500 mb-6"></i>
            <h3 className="text-3xl font-bold text-gray-900 mb-4">Why Book Clubs Matter</h3>
            <p className="text-lg text-gray-700 leading-relaxed">
              Book club members are passionate readers who not only read your book but actively discuss it, recommend it to friends, and leave detailed reviews. They're the ideal audience for authors looking to build genuine readership and lasting impact in the literary community.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
